import { render, staticRenderFns } from "./VerifySecondaryPassword.vue?vue&type=template&id=560b4dbc&scoped=true"
import script from "./VerifySecondaryPassword.vue?vue&type=script&lang=js"
export * from "./VerifySecondaryPassword.vue?vue&type=script&lang=js"
import style0 from "./VerifySecondaryPassword.vue?vue&type=style&index=0&id=560b4dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b4dbc",
  null
  
)

export default component.exports